<div class="form-group">
  <input [type]="inputType" class="form-control rounded-pill px-3 shadow "
         [formControl]="inputFormControl"
         [placeholder]="placeholder">
  <app-form-error [control]="inputFormControl" [isDisplayError]="isDisplayError"
                  [fieldName]="fieldName"></app-form-error>
</div>
